import React from 'react';
import { Form, Input, Button, message, Card } from 'antd';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '@/services/api'
const ResetPassword = () => {
    const [form] = Form.useForm();
    const settings = useSelector(e => e.settings)
    const navigate = useNavigate();
    const { t } = useTranslation();


    const [loading, setLoading] = React.useState(false);

    const location = useLocation();

    const params = new URLSearchParams(location.search);
    const codeParam = params.get('code');
    const emailParam = params.get('email');


    const onFinish = async (values) => {


        const { password, confirm } = values;

        if (password !== confirm) {
            message.error("Passwords do not match.");
            return;
        }

        // Şifre sıfırlama API çağrısı burada yapılabilir

        setLoading(true);

        try {

            await api()({
                method: 'post',
                url: '/webshop/public/auth/forgot-password/reset',
                data: {
                    password: values.password,
                    code: codeParam,
                    email: emailParam

                }
            })
            navigate('/login');
            message.success("Password has been reset successfully.");
            form.resetFields();

        } catch (e) {
            console.error("Error during password reset:", e);
            message.error("An error occurred while resetting the password.");


        } finally {
            setLoading(false);
        }





    };

    return (
        <Card title="Reset Password" style={{ maxWidth: 400, margin: '0 auto', marginTop: 100 }}>


            <div className="login-logo">
                {<div className="flex justify-center">
                    <img

                        onClick={() => navigate('/')}

                        style={{ maxHeight: '140px', width: 'auto', cursor: 'pointer' }} src={settings['base-logo']} alt="Company Logo" />
                </div>}
            </div>

            <br />
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                requiredMark={false}
            >
                <Form.Item
                    label="New Password"
                    name="password"
                    rules={[
                        { required: true, message: 'Please enter your new password!' },
                        { min: 6, message: 'Password must be at least 6 characters.' },
                    ]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item
                    label="Confirm Password"
                    name="confirm"
                    dependencies={['password']}
                    rules={[
                        { required: true, message: 'Please confirm your password!' },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('password') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('Passwords do not match!'));
                            },
                        }),
                    ]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" block>
                        Reset Password
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    );
};

export default ResetPassword;
